export default __webpack_public_path__ + "static/media/nodejs.837f9986.svg";